import React from "react"

const Optional = () => {
  return <span className="c-form__label__optional">(optional)</span>
}

export default Optional
